import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { Field } from 'formik'
import styles from './index.module.scss'
import { InputFieldGroup } from '../InputFieldGroup'

export const KeywordSearchGroupFormKeywordField: FC = () => {
  const { t } = useTranslation(['angels-vcs-startups'])

  return (
    <>
      <p className={styles.label}>{t('キーワード検索')}</p>
      <div className={styles.keywordInput}>
        <Field
          name='keyword'
          type='text'
          fieldType='searchLarge'
          placeholder={t('キーワードを入力')}
          component={InputFieldGroup}
        />
      </div>
    </>
  )
}
